<template>
  <li class="apartment-item search-apartments__item" >
    <figure class="apartment-item__col apartment-item__col apartment-item__col--img">
      <img class="apartment-item__img"   :src="apartment.gallery[0].thumb"   @click="openGallery" v-if="apartment.gallery.length > 0" />
      <img class="apartment-item__img apartment-item__img--mobile"   :src="apartment.gallery[0]['mobile-thumb'] + '?ver=1'"   @click="openGallery" v-if="apartment.gallery.length > 0" />
      <figure class="apartment-item__img-open" @click="openGallery" v-if="apartment.gallery.length > 0">
        <img width="70" src="/assets/site/images/a-img-open.jpg">
        <svg viewBox="0 0 30 30" class="apartment-item__img-open-icon">
          <use xlink:href="/assets/site/images/sprites.svg?ver=12#sprite-zoom-in"></use>
        </svg>
      </figure>
      <img width="70"  src = "/assets/site/images/aprtment-no-photo.svg" v-if="apartment.gallery.length === 0 || !apartment.gallery[0].thumb"/>
      <div class="text-center" style="font-size:0.65rem; margin-top:0.2rem"  v-if="apartment.gallery.length === 0 || !apartment.gallery[0].thumb">Нет фото</div>
    </figure>

    <div class="col-12 col-lg-9 col-xl-7 col-xxl-8 apartment-item__cells-group  order-md-3">

      <div class="apartment-item__col apartment-item__col--search">
        <label class="apartment-item__label">Площадь</label>
        <span class="apartment-item__value">
                        {{apartment.square}} м<sup>2</sup>
                    </span>
      </div>
      <div class="apartment-item__col apartment-item__col--search">
        <label class="apartment-item__label">Комнат</label>
        <span class="apartment-item__value">
                           {{apartment.rooms}}
                    </span>
      </div>

      <div class="apartment-item__col">
        <label class="apartment-item__label">Цена за м<sup>2</sup></label>
        <span class="apartment-item__value" v-if="apartment.price_for_m2">
                        {{apartment.price_for_m2.toLocaleString('ru-RU')}} ₽
                    </span>
      </div>
      <div class="apartment-item__col apartment-item__col--search">
        <label class="apartment-item__label">Цена за все</label>
        <span class="apartment-item__value" v-if="apartment.price">
              {{apartment.price.toLocaleString('ru-RU')}} ₽
        </span>
      </div>
    </div>
    <div class="order-md-2 order-xl-3 apartment-item__btns">
      <button class="btn apartment-item__btn apartment-item__btn--search" @click.prevent="modalShow">
        <template v-if="apartment.price">Забронировать</template>
        <template v-else>Узнать цену</template>
      </button>
    </div>
  </li>
</template>
<script>

export default {
  props:['apartment'],

  data() {
    return {
      type:"",
    }
  },
  methods: {
    modalShow() {
      this.$emit('showModal', {id: this.apartment.id, type:this.type})
    },

    openGallery() {
      let media = this.apartment.gallery.map(function(item){
        return {
          thumb:item.thumb,
          src:item.url,
        }
      });
      this.$emit('open-gallery', media);
    }
  },
  mounted() {
    if(this.apartment.price) {
      this.type = 'Забронировать квартиру';
    } else {
      this.type = "Узнать цену квартиры";
    }
  }
}

</script>